
















































































































































import { defineComponent, ref } from '@vue/composition-api'
import { getCountries } from '~/api/Address/address'
import {
  cancelCarBooking,
  carAgencyController,
  carBookingsController,
  carCategoryController,
  carOfficeController,
  carSeasonsController,
  getCarBookingXls,
} from '~/api/RentalCar'
import AppView from '~/components/AppView.vue'
import ChipStatus from '~/components/ChipStatus.vue'
import CarBookingPdf from '~/components/Services/Cars/CarBookingPdf.vue'
import ConfirmBooking from '~/components/Services/Cars/ConfirmBooking.vue'
import SendCarBookingPdf from '~/components/Services/Cars/SendCarBookingPdf.vue'
import { stepperComposition } from '~/compositions/stepper'
import { DatePicker, Step, TableHeader } from '~/utils/interfaces'
import { CarBooking, CarBookingStatus } from '~/utils/interfaces/rentalCar'
import CarBookingsStepClient from './CarBookingsStepClient.vue'
import CarBookingsStepSearch from './CarBookingsStepSearch.vue'
import CarBookingsStepInfo from './CarBookingsStepInfo.vue'
import CarBookingsStepSelect from './CarBookingsStepSelect.vue'
import Autocomplete from '~/components/Autocomplete.vue'
import CancelButton from '~/components/CancelButton.vue'
import CarBookingInvoice from '~/components/Services/Cars/CarBookingInvoice.vue'
import TextButton from '~/components/TextButton.vue'
import { generateFile } from '~/utils/functions'
export default defineComponent({
  components: {
    AppView,
    CarBookingPdf,
    CarBookingsStepClient,
    CarBookingsStepInfo,
    CarBookingsStepSearch,
    CarBookingsStepSelect,
    ChipStatus,
    ConfirmBooking,
    SendCarBookingPdf,
    Autocomplete,
    CancelButton,
    CarBookingInvoice,
    TextButton,
  },
  setup(_props, { root }) {
    const { components, model } = stepperComposition()
    const rejectFunction = () => {
      if (model.value === 1) return true
      else {
        model.value--
        return false
      }
    }
    const view = ref()
    const loadingExcel = ref(false)
    const onGenerateExcel = async () => {
      loadingExcel.value = true
      try {
        const filters = view.value.table.lastFilter
        const response = await getCarBookingXls(filters)
        generateFile(
          response,
          root.$t('car_bookings') + new Date().toLocaleDateString() + '.xls',
        )
      } finally {
        loadingExcel.value = false
      }
    }

    return {
      components,
      rejectFunction,
      stepperModel: model,
      bookingStatuses: CarBookingStatus,
      loadingExcel,
      onGenerateExcel,
      view,
    }
  },
  data() {
    return {
      controller: carBookingsController,
      headers: [
        {
          text: this.$t('code'),
          value: 'code',
        },
        {
          text: this.$t('client'),
          value: 'client',
        },
        {
          text: this.$t('cost'),
          value: 'cost',
        },
        {
          text: this.$t('price'),
          value: 'price',
        },
        {
          text: this.$t('pick_office'),
          value: 'pick_office_name',
        },
        {
          text: this.$t('drop_office'),
          value: 'drop_office_name',
        },
        {
          text: this.$t('start_datetime'),
          value: 'start_datetime',
        },
        {
          text: this.$t('end_datetime'),
          value: 'end_datetime',
        },
        {
          text: this.$t('from_agency'),
          value: 'from_agency_name',
        },
        {
          text: this.$t('status'),
          value: 'status',
        },
        {
          text: this.$t('created_at'),
          value: 'created_at',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader<CarBooking>[],
      defaultCrud: {
        pick_office: '',
        drop_office: '',
        start_datetime: '',
        end_datetime: '',
        category: '',
        price: '',
        flight_code: '',
        description: '',
        client: {
          identity: '',
          first_name: '',
          last_name: '',
          nationality: null,
          email: '',
          phone: '',
        },
        flight_terminal: '',
        flight_datetime: null,
      },
      steps: [
        {
          name: this.$t('search'),
          component: 'CarBookingsStepSearch',
        },
        {
          name: this.$t('select'),
          component: 'CarBookingsStepSelect',
        },
        {
          name: this.$t('client'),
          component: 'CarBookingsStepClient',
        },
        {
          name: this.$t('optional'),
          component: 'CarBookingsStepInfo',
        },
      ],
      booleanItems: [
        { text: this.$t('yes'), value: 'true' },
        { text: this.$t('no'), value: 'false' },
      ],
      statusItems: Object.entries(CarBookingStatus).map(([key, value]) => ({
        text: this.$t(key),
        value,
      })),
    }
  },
  methods: {
    cancelCarBooking,
    getCarAgencies: carAgencyController.getter,
    getCarOffices: carOfficeController.getter,
    getCarCategories: carCategoryController.getter,
    getCarSeason: carSeasonsController.getter,
    getCountries,
    validateFunction() {
      const components = this.$refs.components as Step[]
      if (!components[this.stepperModel - 1].onNext()) return false
      if (this.stepperModel === components.length) return true
      else {
        this.stepperModel++
        return false
      }
    },
    serializeFilter(filter: Record<string, string>) {
      const createdAt = (this.$refs.createdAt as DatePicker).getData()
      return {
        ...filter,
        booking__created_at__lte: createdAt.maxDate,
        booking__created_at__gte: createdAt.maxDate,
      }
    },
    onDialogInput(v: boolean) {
      if (!v) {
        this.stepperModel = 1
        ;(this.$refs.view as InstanceType<typeof AppView>).resetFormValidation()
      }
    },
  },
})
